import React, { useEffect } from 'react'
import FormRow from './FormRow'
import useForm from 'js/hooks/useForm'

const schema = [
  {
    "name": "phoneno",
    "label": "Phone Number",

  },
  {
    "name": "email",
    "label": "Email",

  },
  {
    "name": "firstname",
    "label": "First Name",

  },
  {
    "name": "lastname",
    "label": "Last Name",

  },
  {
    "name": "gender",
    "label": "Gender",
    type: "select",
    "options": [
      { value: "", label: "Select One"},
      { value: "M", label: "Male"},
      { value: "F", label: "Female"},
      // { value: "O", label: "Other"}
    ]
  },
  {
    "name": "dob",
    "label": "Date of Birth",
    type: "date"
  },
  {
    "name": "nationality",
    "label": "Nationality",
    type: "select",
    options: [
      { value: "", label: "Select One"},
      "India",
      "United States",
      "China",
      "Japan",
      "Germany",
      "United Kingdom",
      "France",
      "Italy",
      "Brazil",
      "Canada"
    ]
  },
  {
    "name": "religion",
    "label": "Religion",
    type: "select",
    "options": [
      { value: "", label: "Select One"},
      "Hinduism",
      "Christianity",
      "Islam",
      "Buddhism",
      "Sikhism",
      "Judaism"
    ]
  },
  {
    "name": "marital_status",
    "label": "Marital Status",
    type: "select",
    "options": [
      { value: "", label: "Select One"},
      "Single",
      "Married",
      "Divorced",
      "Widowed"
    ]
  },
  {
    "name": "highest_edu",
    "label": "Highest Education",

  },
  {
    "name": "profession",
    "label": "Profession",

  },
  {
    "name": "monthly_income",
    "label": "Monthly Personal Income",

  },
  {
    "name": "tot_fam_income",
    "label": "Monthly Family Income",

  },
  {
    "name": "tot_dependants",
    "label": "No. of Dependents",

  },
  {
    "name": "cibil_score",
    "label": "CIBIL Score",

  },
  {
    "name": "is_guarantor",
    "label": "Guarantor",
    type: "select",
    "options": [
      { value: "", label: "Select One"},
      "No",
      "Yes"
    ]
  },
  {
    "name": "address.address_line1",
    "label": "Address Line 1",

  },
  {
    "name": "address.address_line2",
    "label": "Address Line 2",

  },
  {
    "name": "address.cur_town",
    "label": "Town/City",

  },
  {
    "name": "address.state",
    "label": "State",

  },
  {
    "name": "address.district",
    "label": "District",

  },
  {
    "name": "address.country",
    "label": "Country",

  },
  {
    "name": "address.pincode",
    "label": "Pincode",

  },
  {
    "name": "address.period_of_stay",
    "label": "Period of stay at the above address in years",

  },
  {
    "name": "address.address_type",
    "label": "Address Type",
    type: "select",
    "options": [
      { value: "", label: "Select One"},
      "Permanent",
      "Temporary"
    ]
  },
  {
    "name": "identity_proof",
    "label": "ID Proof",
    type: "select",
    "options": [
      { value: "", label: "Select One"},
      "Aadhar",
      "PAN",
      "Driving License"
    ]
  },
  {
    "name": "address_proof",
    "label": "Address Proof",
    type: "select",
    "options": [
      { value: "", label: "Select One"},
      "Ration Card",
      "House Agreement"
    ]
  },
  {
    "name": "income_proof",
    "label": "Income Proof",
    type: "select",
    "options": [
      { value: "", label: "Select One"},
      "ITR",
      "Salary Slip",
      "Bank Statement"
    ]
  }
]

const names = schema.filter(d => d.name.startsWith("address.")).map(d => d.name.replace("address.", ""))

export default function Step4({ payload, onChange }) {

  const prev = { ...payload.coapplicant }
  names.map(d => {
    prev["address." + d] = payload.coapplicant?.address?.current_address[d] || ''
  })
  const { values: coapplicant, inputProps } = useForm({ schema, payload: prev })

  const onClick = () => {

    let data = {
      coapplicant_user_id: 0,
      firstname: coapplicant?.firstname || "",
      lastname: coapplicant?.lastname || "",
      gender: coapplicant?.gender || "",
      dob: coapplicant?.dob || "",
      phoneno: coapplicant?.phoneno || null,
      email: coapplicant?.email || null,
      nationality: coapplicant?.nationality || "",
      religion: coapplicant?.religion || "",
      marital_status: coapplicant?.marital_status || "",
      highest_edu: coapplicant?.highest_edu || "",
      profession: coapplicant?.profession || "",
      monthly_income: coapplicant?.monthly_income || "",
      tot_fam_income: coapplicant?.tot_fam_income || "",
      tot_dependants: coapplicant?.tot_dependants || "",
      cibil_score: coapplicant?.cibil_score || "",
      covenants_risks: "No",
      identity_proof: coapplicant?.identity_proof || "",
      address_proof: coapplicant?.address_proof || "",
      income_proof: coapplicant?.income_proof || "",
      profile_pic: null,
      identity_proof_copy: coapplicant?.identity_proof_copy || "",
      address_copy: coapplicant?.address_copy || "",
      income_copy: coapplicant?.income_copy || "",
      is_guarantor: false,
      status: "active",
      address: {
        current_address: {
          address_line1: coapplicant["address.address_line1"] || "",
          address_line2: coapplicant["address.address_line2"] || "",
          cur_town: coapplicant["address.cur_town"] || "",
          city: coapplicant["address.city"] || "",
          district: coapplicant["address.district"] || "",
          state: coapplicant["address.state"] || "",
          country: coapplicant["address.country"] || "",
          pincode: coapplicant["address.pincode"] || "",
          address_type: "permanent",
          period_of_stay: coapplicant["address.period_of_stay"] || "",
        },
        // permanent_address: {
        //   address_line1: "",
        //   address_line2: "",
        //   cur_town: "",
        //   city: "",
        //   district: "",
        //   state: "",
        //   country: "",
        //   pincode: "",
        //   address_type: "",
        //   period_of_stay: "",
        // },
      },
      default_shipping_flag: 1,
      default_billing_flag: 1,
      default_communication: 1,
    }
    onChange({ coapplicant: data })
  }

  useEffect(() => {
    const btn = document.getElementById("submit")
    btn.addEventListener("click", onClick)

    return () => {
      btn.removeEventListener("click", onClick)
    }
  }, [coapplicant])


  return (
    <div>
      <h5 className="card-title" style={{ fontSize: 14, fontStyle: 'italic', textAlign: 'center' }}>Skip this step if there is no co-applicant</h5>
      <br />
      {schema.map(d => <FormRow key={d.name} {...inputProps(d)} />)}
    </div>
  )
}
